import { Component, OnInit, AfterViewChecked, ChangeDetectorRef, AfterViewInit, OnChanges  } from '@angular/core';
import { Subject } from 'rxjs/Subject';
// import {  } from '@angular/core/src/metadata/lifecycle_hooks';
import { SharedServiceService } from '../shared/shared-service.service';
import { LoaderComponent } from '../loader/loader.component';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit, AfterViewChecked, OnChanges {

  // loading: boolean = false;
  accountFlag: boolean = true;
  shopFlag: boolean = false;
  orderFlag: boolean = false;
  invoiceFlag: boolean = false;
  // public static loadingV: Subject<any> = new Subject();

  constructor(private sharedService: SharedServiceService, private cdRef:ChangeDetectorRef) { }


  ngAfterViewChecked() {
    // LoaderComponent.loadingV.subscribe(res => {
    //   this.loading = res;
    // });
    this.refreshScreen(this.sharedService.getFooterValue());
    this.sharedService.getFooterSelected().subscribe(data => {
      this.refreshScreen(data);
    });
    this.cdRef.detectChanges();

  }

  ngOnChanges() {
    // LoaderComponent.loadingV.subscribe(res => {
    //   this.loading = res;
    // });
  }


  ngOnInit() {

    // this.refreshScreen(this.sharedService.getFooterValue());
    // this.sharedService.getFooterSelected().subscribe(data => {
    //   this.refreshScreen(data);
    // });
    
  }

  refreshScreen(data) {
    if (data === 'account') {
      this.changeFlags(true, false, false, false);
    } else if (data === 'shop') {
      this.changeFlags(false, true, false, false);
    } else if (data === 'order') {
      this.changeFlags(false, false, true, false);
    } else if (data === 'invoice') {
      this.changeFlags(false, false, false, true);
    }
  }

  changeFlags(account, shop, order, invoice) {
    this.accountFlag = account;
    this.shopFlag = shop;
    this.orderFlag = order;
    this.invoiceFlag = invoice;
  }

}


// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts